<template>
  <div class="questionnaire-info">
    <p class="questionnaire__title">
      Укажи обязательные данные,
      чтобы продолжить регистрацию
    </p>
    <div
      v-if="!isLoading"
      class="questionnaire-info__field-list"
    >
      <UiInput
        v-model="user.lastname"
        title="Фамилия"
        placeholder="Введи фамилию"
        :popup="validPopup(!$v.user.lastname.required, 'Обязательное поле')"
      />
      <UiInput
        v-model="user.name"
        title="Имя"
        placeholder="Введи имя"
        :popup="validPopup(!$v.user.name.required, 'Обязательное поле')"
      />
      <UiInput
        v-model="user.patronymic"
        title="Отчество"
        placeholder="Введи отчество"
        :popup="validPopup(!$v.user.patronymic.required, 'Обязательное поле')"
      />
      <UiInput
        v-model="user.phone"
        class="profile-edit__input"
        title="Телефон"
        placeholder="Введи номер телефона"
        :popup="validPopup(!$v.user.phone.required, 'Обязательное поле')"
      />
      <UiInput
        v-model="user.email"
        title="Email"
        placeholder="Введи почту"
        :error="$v.$dirty && (!$v.user.email.required || !$v.user.email.email)"
        :popup="validPopup(!$v.user.email.required, 'Обязательное поле') ||
          validPopup(!$v.user.email.email, 'Некорректный email')
        "
      />
      <UiCityInput
        v-model="user.city"
        title="Местоположение"
        placeholder="Введи своё местоположение"
        :popup="validPopup(!$v.user.city.required, 'Обязательное поле')"
      />
      <UiSelectFilter
        v-model="user.timezone"
        title="Часовой пояс"
        placeholder="В каком часовом поясе проживаете"
        :option="timezoneList"
        :max-height="200"
        :popup="validPopup(!$v.user.timezone.required, 'Обязательное поле')"
      />
    </div>
    <div
      v-else
      class="questionnaire-info__field-list"
    >
      <div
        v-for="(item, idx) in user"
        :key="idx"
        class="ajax__line -round-"
        :style="{width: '100%', height: '51px'}"
      />
    </div>
    <UiCheckbox
      v-model="privacyPolicy"
      class="questionnaire-info__checkbox"
      :class="{'-error-': $v.$dirty && !$v.privacyPolicy.check}"
    >
      Я согласен с 
      <a
        href="https://docs.google.com/document/d/1l9I4EyDn7thrLgVAWwM-Eh4r_B5XS-2r-3m6dbZT0J0/edit"
        target="_blank"
      >Политикой Конфиденциальности
      </a> и 
      <a
        href="https://docs.google.com/document/d/1Z4I_yLTtUeJxyKyV8Ps6dcoYHQFZX7_A4sQlG8595pM/edit?usp=sharing"
        target="_blank"
      >Офертой
      </a>
    </UiCheckbox>
    <div class="questionnaire-info__footer -center-">
      <UiButton
        class="-warning-"
        @click="sendUser"
      >
        Продолжить
      </UiButton>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import UiCityInput from '@/components/UiKit/CityInput';

export default {
  components: { UiCityInput },
  data: () => ({
    user: {
      name: '',
      lastname: '',
      patronymic: '',
      phone: '',
      email: '',
      city: '',
      // telegram: '',
      timezone: ''
    },
    privacyPolicy: true
  }),
  computed: {
    ...mapState('auth', {
      userData: s => s.data.user,
      timezoneList: s =>
        s.data.timezoneList.map(({ id, name }) => ({ value: id, title: name })),
      getUserData: s => s.meta.getUserData,
      gettingTimezone: s => s.meta.gettingTimezone
    }),
    ...mapState('questionnaire', {
      questionList: s => s.data.questionList
    }),
    isLoading() {
      return !this.getUserData || this.gettingTimezone;
    }
  },
  watch: {
    getUserData() {
      this.setUserData();
    }
  },
  mounted() {
    if (this.getUserData) {
      this.setUserData();
    }
    this.$store.dispatch('auth/getTimezoneList');
  },
  methods: {
    validPopup(isErr, text) {
      if (!this.$v.$dirty) {
        return;
      }
      if (isErr) {
        return {
          msg: text,
          error: true
        };
      }
    },
    async sendUser() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      const sendData = { ...this.user, timeZone: this.user.timezone };
      delete sendData.timezone;
      await this.$store.dispatch('settingStore/setData', {
        path: 'stagedUserMain',
        value: sendData
      });
      const status = await this.$store.dispatch('settingStore/settingUpdate', {
        type: 'main'
      });
      if (status) {
        if (!this.questionList.length) {
          await this.$store.dispatch('questionnaire/getQuestionnaireList');
        }
        this.$store.dispatch(
          'questionnaire/setQuestion',
          this.questionList.find(q => q.first).id ?? this.questionList[0].id
        );
      }
    },
    setUserData() {
      Object.keys(this.user).forEach(key => {
        this.user[key] = this.userData[key];
      });
    }
  },
  validations: {
    user: {
      name: { required },
      lastname: { required },
      patronymic: { required },

      email: { required, email },
      city: { required },
      phone: { required },
      timezone: { required }
    },
    privacyPolicy: {
      check(value) {
        return value;
      }
    }
  }
};
</script>

<style></style>
